// Dynamic title-tag builder for automated database pages (guides, guide
// articles). Google requires each indexable page to carry a distinct title;
// naive truncation of long-tail titles at 60 characters collapsed sibling
// articles ("… — Quick Reference" / "… — Advanced Tips") into identical
// strings. This helper keeps the distinguishing trailing segment intact and
// clips the shared lead instead, so titles stay unique and compliant.

export function clipTitle(s: string, n: number) {
  const t = s.replace(/\s+/g, " ").trim();
  if (t.length <= n) return t;
  const cut = t.slice(0, n - 1);
  const space = cut.lastIndexOf(" ");
  return (space > 0 ? cut.slice(0, space) : cut).replace(/[,;:.\-—]$/, "") + "…";
}

export function pageTitle(raw: string, max = 60) {
  const t = raw.replace(/\s+/g, " ").trim();
  const full = `${t} — Pal Stars`;
  if (full.length <= max) return full;
  if (t.length <= max) return t;

  const idx = t.lastIndexOf(" — ");
  if (idx > 0) {
    const head = t.slice(0, idx);
    const tail = t.slice(idx + 3);
    const room = max - (tail.length + 3);
    if (room >= 16) return `${clipTitle(head, room)} — ${tail}`;
    return clipTitle(tail, max);
  }
  return clipTitle(t, max);
}
